module.exports = __webpack_public_path__ + "90d86a4ef187351b58532cc80e71cd72.svg";